import { useEffect, useState } from "react";
import api from "../../../../Component/axios";

export const useTipoCaja = (tamano_envase_id) => {
  const [tipoCaja, setTipoCaja] = useState([]);
  useEffect(() => {
    const getTipoCaja = async () => {
      const token = localStorage.getItem("@Token");
      try {
        const response = await api.get(`api/etiquetas/tipo_caja/`, {
          params: { id_tamano_envase: tamano_envase_id },
          headers: {
            Authorization: "Token " + token,
          },
        });
        setTipoCaja(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getTipoCaja();
  }, [tamano_envase_id]);

  return { tipoCaja };
};
